import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';
import DiscountBanner from '../components/DiscountBanner';

export default function Account() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get('/consultations').then(r => setItems(r.data)); }, []);

  return (
    <main className="bg-stilo-bg min-h-[70vh]" data-testid="account-page">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-12 pt-16 pb-32">
        <p className="overline">Mi cuenta</p>
        <h1 className="font-serif text-6xl mt-3 leading-[0.95]">Hola, {user?.name?.split(' ')[0]}.</h1>
        <div className="mt-8"><DiscountBanner /></div>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4">
          <Link to="/asesorias" className="border border-stilo-ink/10 bg-stilo-beige p-6 hover:bg-white transition-colors" data-testid="cta-new-consult"><p className="overline">+ Nueva</p><p className="font-serif text-2xl mt-3">Reservar asesoría</p></Link>
          <Link to="/asesorias" className="border border-stilo-ink/10 bg-stilo-beige p-6 hover:bg-white transition-colors"><p className="overline">Asesorías</p><p className="font-serif text-2xl mt-3">Studio Stilo</p></Link>
        </div>

        <h2 className="font-serif text-3xl mt-16">Mis asesorías</h2>
        <div className="mt-6 border-t border-stilo-ink/10">
          {items.length === 0 && <p className="py-12 text-stilo-ink3">Aún no tienes asesorías. <Link to="/asesorias" className="underline text-stilo-ink">Reserva la primera</Link>.</p>}
          {items.map(c => (
            <Link to={`/asesoria/${c.id}`} key={c.id} className="flex justify-between py-5 border-b border-stilo-ink/10 hover:bg-stilo-beige px-3 transition-colors" data-testid={`consult-${c.id}`}>
              <div>
                <p className="overline">{c.modality === 'live' ? 'Videollamada' : 'Asíncrona'}</p>
                <p className="font-serif text-2xl mt-1">{c.package_name}</p>
              </div>
              <span className="text-stilo-ink2 text-sm self-center">Abrir →</span>
            </Link>
          ))}
        </div>
      </div>
    </main>
  );
}
